var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[(_vm.org)?_c('v-card',{attrs:{"flat":""}},[_c('GroupActions')],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }